import React, { useMemo } from "react";
import classNames from "classnames";
import { IEvidence, ProgramData, ProgramSkill, SkillsMultiSelectSelectedValue } from "@interfaces/Interfaces";
import * as EvidenceUtils from "@utils/evidenceUtils";
import { useProgramCycles } from "@hooks/programs/useProgramCycles";

type Props = {
  sortedSkillsForRole: ProgramSkill[];
  programEvidence: IEvidence[];
  program: ProgramData;
  collapse?: boolean;
};

const ProgramSkillsCard: React.FC<Props> = (props) => {
  const { currentProgramCycle } = useProgramCycles(props.program.ID);

  const evidenceWithSkills = useMemo(
    () => props.programEvidence.filter((evidence) => EvidenceUtils.evidenceHasSkills(evidence, props.program.ID)),
    [props.programEvidence]
  );

  const skillsWithinEvidence: SkillsMultiSelectSelectedValue[] = useMemo(
    () => evidenceWithSkills.flatMap((evidence) => evidence.evidenceJSON.SkillsSelect),
    [evidenceWithSkills]
  );

  const count = useMemo(
    () =>
      EvidenceUtils.getSkillsCountForDisplayCard({
        skillsWithinEvidence,
        evidenceWithSkills,
        programID: props.program.ID,
        currentProgramCycle,
      }),
    [skillsWithinEvidence, evidenceWithSkills, currentProgramCycle]
  );

  return (
    <div>
      <div
        className={classNames("flex flex-row items-end mt-1 mb-4", {
          "mb-0": props.collapse,
        })}
      >
        <div className="text-acc-34px font-acc-700 tracking-[-0.5] leading-none text-green-light-text">{count}</div>
        <div className="text-acc-15px font-acc-700 tracking-default leading-none text-grey-90 mb-1">
          &nbsp;{`Skill${count !== 1 ? "s" : ""} added`}
        </div>
      </div>
    </div>
  );
};

export default ProgramSkillsCard;
